module.exports = __webpack_public_path__ + "media/images/ads/brands_mobile-56609ff29b43d6a4b1eb9ed52b609109.png";